import { resolveStatsSchema } from "@redotech/redo-dispute-db-schema/dispute-deflection-analytics";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getResolveStats = {
  name: "getResolveStats" as const,
  input: z.object({
    startDate: zExt.plainDate().optional(),
    endDate: zExt.plainDate().optional(),
  }),
  output: resolveStatsSchema,
};
